/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2023-03-06 14:43:16
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-03-07 17:21:45
 */
const router = [
  //强制匹配404页面
  {
    path: "/pc/map",
    meta: {
      title: "map",
      needLogin: false,
      waterMark: false
    },
    component: () => import(/* webpackChunkName: "map" */ '../views/Map'),
  },
  // {
  //   path: "/pc/economic",
  //   meta: {
  //     title: "经济运行监测系统",
  //     needLogin: false,
  //   },
  //   component: () => import(/* webpackChunkName: "economic" */ "../views/economicSupervision"),
  //   redirect: "/pc/economic/operation",
  //   children: [
  //     {
  //       path: "operation",
  //       meta: {
  //         title: "经济运行",
  //         needLogin: false,
  //       },
  //       linkActiveClass: "item-bg-h",
  //       component: () => import(/* webpackChunkName: "economic-operation" */ "../views/economicSupervision/economicalOperation/economicalOperation.vue"),
  //     }
  //   ],
  // },
  // {
  //   path: "/pc/dataManagerPlatform",
  //   meta: {
  //     title: "数据管理平台",
  //     needLogin: false,
  //   },
  //   component: () => import(/* webpackChunkName: "data-manager" */ "../views/dataManagerPlatform"),
  // }
]

export default router;